<template>
  <div>
    <v-card flat outlined>
      <v-card-title>Preview</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-for="field in customFields"
            :key="field.key"
            cols="12"
            md="6"
          >
            <custom-field-renderer
              :field="field"
              v-model="fieldValues[field.key]"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CustomFieldRenderer from "./CustomFieldRenderer.vue";

export default {
  name: "CustomFieldExample",
  components: {
    CustomFieldRenderer
  },
  props: {
    customFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fieldValues: {},
      isFormValid: false
    };
  },
  created() {
    // Inicializar valores por defecto
    this.customFields.forEach(field => {
      this.fieldValues[field.key] = this.getDefaultValue(field);
    });
  },
  methods: {
    getDefaultValue(field) {
      switch (field.type) {
        case "string":
          return "";
        case "number":
          return null;
        case "boolean":
          return false;
        case "array":
          return [];
        default:
          return null;
      }
    }
  }
};
</script>
